export default (function (data) {
  var convertEntities = document.createElement("textarea");
  convertEntities.innerHTML = "".concat(data);
  return convertEntities.value;
});